export var CountryEnum;
(function (CountryEnum) {
    CountryEnum["FRANCE"] = "FR";
    CountryEnum["DEUTSCHLAND"] = "DE";
    CountryEnum["BELGIQUE"] = "BE";
})(CountryEnum || (CountryEnum = {}));
export var CountryIdEnum;
(function (CountryIdEnum) {
    CountryIdEnum["FRANCE"] = "AD02FR1";
    CountryIdEnum["DEUTSCHLAND"] = "AD02DE1";
    CountryIdEnum["BELGIQUE"] = "AD02BE1";
})(CountryIdEnum || (CountryIdEnum = {}));
